import { useTranslation } from "react-i18next";
import { getModalService, getToasterService } from "@asd-stan/shell/infrastructure/getters";
import { getStandardDetailsService, getStagesService } from "@asd-stan/standard/infrastructure/getters";
import { Form, Formik } from "formik";
import { ReactComponent as CloseIcon } from './assets/close.svg';
import {
    ButtonsContainer,
    CloseBtn,
    StageContainer,
    StageHeader
} from "@asd-stan/standard/components/single-standard/stage-update/stage-update.styled";
import {
    TitleWrapper
} from "@asd-stan/standard/components/single-standard/stage-update/additional/additional.styled";
import { Button } from "@components/button/button";
import { ToasterStatus } from "@asd-stan/shell/domain/toaster.service";

export const DeleteTransactionModal = (
    {
        standardId,
        transactionId,
        onSubmit
    }: {
        standardId: number;
        transactionId: number;
        onSubmit(): void;
    }) => {
    const { t } = useTranslation();
    const modalService = getModalService();
    const toasterService = getToasterService();
    const standardDetailedService = getStandardDetailsService();
    const stagesService = getStagesService();

    const handleSubmit = async () => {
        try {
            await standardDetailedService.deleteTransaction(standardId, transactionId);
            if (standardDetailedService.standard?.form) {
                await stagesService.getNewStageOptions(standardDetailedService.standard.form, standardId);
            }
            closeModal();
            toasterService.showToast(
                ToasterStatus.success,
                t('standard.singleStandard.stageAndStatus.deleteModal.success')
            );
            onSubmit();
        } catch (err: any) {
        }
    };

    const closeModal = () => modalService.closeModal();

    return (
        <Formik initialValues={{}} onSubmit={handleSubmit}>
            {({ isSubmitting }) => (
                <StageContainer as={Form}>
                    <StageHeader>{t('standard.singleStandard.stageAndStatus.deleteModal.title')}</StageHeader>
                    <CloseBtn onClick={closeModal}>
                        <CloseIcon/>
                    </CloseBtn>
                    <TitleWrapper style={{ width: '100%' }}>
                        <p className="subTitle">
                            {t('standard.singleStandard.stageAndStatus.deleteModal.subTitle')}
                        </p>
                    </TitleWrapper>
                    <ButtonsContainer>
                        <Button
                            fullWidth
                            secondary
                            disabled={isSubmitting}
                            title={t('standard.singleStandard.stageAndStatus.deleteModal.cancel')}
                            onClick={closeModal}
                        />
                        <Button
                            fullWidth
                            title={t('standard.singleStandard.stageAndStatus.deleteModal.confirm')}
                            disabled={isSubmitting}
                            type="submit"
                        />
                    </ButtonsContainer>
                </StageContainer>
            )}
        </Formik>
    );
};
